module.exports = __webpack_public_path__ + "media/src/img/payment/kseniya_tinkoff_logo-ee785c9e8cf6c6a929af5a70b1df8785.png";